// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_VyR","cls2":"PaperBrowserPreviewList-cls2_h0V PaperBrowserPreviewList-cls1_VyR"};